import React, { useEffect, useState } from 'react';
import WebService from '../../../api/explus-api';


const Events = () => {
    const [events, updateEvents] = useState([]);

    useEffect(() => {
        const appUrl = WebService.getAppUrl()
        // const request = WebService.requestGet(appUrl + '/web/events');
        // request.then(res => {
        //     updateEvents(res);
        // });
    }, []);

    function showEventDetails(event) {
        return event.map((evt, i) => {
            return <ul key={i} className="text-left" style={{paddingLeft: '20px', listStyle: 'circle'}}>
                <li> <span style={{color: '#3a3a3a', fontWeight: '600',fontStyle: 'italic'}}>{ evt.day[0] } { evt.day[1] }</span> - { evt.description }</li>
            </ul>
        });
    }

    function showEvents() {
        if (events.length < 1) return '';

        const element = [];

        for (let key in events) {
            element.push(
                <div key={Math.random().toString(36).substr(2, 9)} className="timeline-wrapper" style={{borderBottom: '1px solid #000', marginBottom: '25px'}}>

                    <h4 style={{textAlign: 'left', color: '#ff6600', fontWeight: '600'}}><i className="far fa-calendar-alt"></i> { key.replace('_', ' ') }</h4>

                    {showEventDetails(events[key])}
                </div>
            )
        }

        return element;

        // return events.map(event => {
        //     return <div className="timeline-wrapper">

        //         {/* <h4 style={{fontSize: '14px'}}>{ event.event_description }</h4> */}

        //         {event.map(evt => {
        //             return <div className="text-left" style={{borderBottom: '1px solid #000'}}>
        //                 <p><i className="far fa-calendar-alt"></i> { evt.day[0] } { evt.day[1] } { evt.description }</p>
        //             </div>
        //         })}
        //     </div>
        // });
    }

    return (
        <div className="homeupdates">
            <h2>Events</h2>
            { showEvents() }
        </div>
    );
}
 
export default Events;